
import { ImageFit, ImageHorizontalAlign, ImageStyledProperty, ImageVerticalAlign } from "@/utils/documents/image-styled-property";
import AppStyleEditorBorder from "./StyleEditorBorder.vue";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import AppColorPicker from "@/components/ColorPicker.vue";

export default Vue.extend({
	data(){
		return {
			toEditStyle: new ImageStyledProperty(),
			tab: 0
		};
	},
	props: {
		value: {
			type: Object as ()=>ImageStyledProperty,
			required: true
		}
	},
	computed: {
		tabs(): any {
			return this.$ct("tabs.style");
		},
		generalText(): string {
			return "";
		},
		horizontalAlignItems():ISelectItem<ImageHorizontalAlign>[]{
			return [
				{
					text: this.$ct("common.Left"),
					value: ImageHorizontalAlign.LEFT
				},
				{
					text: this.$ct("common.Center"),
					value: ImageHorizontalAlign.CENTER
				},
				{
					text: this.$ct("common.Right"),
					value: ImageHorizontalAlign.RIGHT
				}
			];
		},
		verticalAlignItems():ISelectItem<ImageVerticalAlign>[]{
			return [
				{
					text: this.$ct("common.Top"),
					value: ImageVerticalAlign.TOP
				},
				{
					text: this.$ct("common.Middle"),
					value: ImageVerticalAlign.MIDDLE
				},
				{
					text: this.$ct("common.Bottom"),
					value: ImageVerticalAlign.BOTTOM
				}
			];
		},
		fitItems():ISelectItem<ImageFit>[]{
			return [
				{
					text: this.$ct("image-fit.fill"),
					value: ImageFit.FILL
				},
				{
					text: this.$ct("image-fit.contain"),
					value: ImageFit.CONTAIN
				},
				{
					text: this.$ct("image-fit.cover"),
					value: ImageFit.COVER,
				},
				{
					text: this.$ct("image-fit.none"),
					value: ImageFit.NONE
				}
			];
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.toEditStyle = new ImageStyledProperty(this.value.getJSON());
				console.log(this.toEditStyle.getStyle());
			}
		}
	},
	methods: {
		closeClicked() {
			this.$emit("close");
		},
		updateValue() {
			this.value.setValues(this.toEditStyle.getJSON());
			this.$emit("close");
		}
	},
	components: {
		AppStyleEditorBorder,
		AppColorPicker
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
